exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popup-body .btn-style-outline-secondary[data-v-2123b4e6]{\n\tcolor: #B1A781;\n\tborder: 1px solid #B1A781;\n\tbackground-color: transparent;\n}\n.popup-body .btn-style-outline-secondary[data-v-2123b4e6]:hover,\n.popup-body .btn-style-outline-secondary[data-v-2123b4e6]:focus {\n\tcolor: #FFF;\n\tborder: 1px solid #B1A781;\n\tbackground-color: #B1A781;\n}\n", ""]);

// exports
